module.exports = __webpack_public_path__ + "img/3.e815c638.png";